import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/style.css'
import VueRouter from 'vue-router'
import router from '@/router/index'
// import firebase from "firebase";
import { store } from './store'
import VueParticlesBg from "particles-bg-vue";

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueParticlesBg);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
